export default __webpack_public_path__ + "static/media/Image2.33b43b76.png";